<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" fab fixed bottom right dark v-on="on" class="mb-5 mr-5">
            <v-icon>help</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>FAQS</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-layout row wrap>
            <v-flex>
              <v-container fluid>
                <v-flex v-if="failed">DOCUMENTATION NOT FOUND</v-flex>
                <v-flex v-else>
                  <v-card class="elevation-0" v-on:language="getData()">
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex md3>
                          <v-list id="menu">
                            <v-list-tile @click="setQuest(quest.url)" v-for="quest in quests" ripple v-bind:key="quest.id">
                              <v-list-tile-action>
                                <v-icon :color="quest.url === quest_selected ? 'primary' : 'grey'">help</v-icon>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <h4 class="mt-2">¿{{ quest.title }}?</h4>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-flex>

                        <v-flex md8 class="ml-5">
                          <v-tabs centered color="#D5D5D5" dark icons-and-text v-model="tab">
                            <v-tabs-slider color="primary"></v-tabs-slider>

                            <v-tab class="tw-txt-color-primary" v-for="step in steps" v-bind:key="`step_${step.id}`" :href="`#tab-${step.id}`" @click="setStep(step.id)">
                              <v-icon class="tw-txt-color-primary">label_important</v-icon>
                              STEP {{ step.id }}
                            </v-tab>

                            <v-tab-item v-if="tab === 'tab-01'" value="tab-01">
                              <v-card flat>
                                <v-card-text>
                                  <faqs-show :show="`${this.quest_selected}/${this.step_selected}`" />
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item v-if="tab === 'tab-02'" value="tab-02">
                              <v-card flat>
                                <v-card-text>
                                  <faqs-show :show="`${this.quest_selected}/${this.step_selected}`" />
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item v-if="tab === 'tab-03'" value="tab-03">
                              <v-card flat>
                                <v-card-text>
                                  <faqs-show :show="`${this.quest_selected}/${this.step_selected}`" />
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item v-if="tab === 'tab-04'" value="tab-04">
                              <v-card flat>
                                <v-card-text>
                                  <faqs-show :show="`${this.quest_selected}/${this.step_selected}`" />
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                          </v-tabs>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import FaqsShow from '@/components/FaqsShow'
import iw1 from '@/assets/logo-trawling.svg'

export default {
  components: { FaqsShow },
  computed: {
    ...mapGetters(['getServer', 'getTokenHeader'])
  },
  created() {
    this.actlang = this.$i18n.locale
    this.getData()
  },

  data() {
    return {
      step_selected: '',
      quest_selected: '',
      failed: false,
      quests: [],
      steps: [],
      content: '',
      iw1,
      tab: 'tab-01',
      faq: 1,
      e1: 0,
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false
    }
  },

  methods: {
    showfaq(ff) {
      this.faq = ff
    },
    getItem(quest, step) {
      const lang = this.$i18n.locale
      const server = 'https://dashboard.trawlingweb.com/api'
      //const server = this.getServer
      this.$http
        .get(`${server}/faqs/${lang}/${quest}/${step}`, this.getTokenHeader)
        .then(datacontent => {
          this.content = datacontent.data
          this.step_selected = step
        })
        .catch(() => {
          this.content = ''
        })
    },
    getStep(quest) {
      const lang = this.$i18n.locale
      const server = 'https://dashboard.trawlingweb.com/api'
      //const server = this.getServer
      if (quest) {
        this.$http.get(`${server}/faqs/${lang}/${quest}/liststep`, this.getTokenHeader).then(datacontent => {
          this.steps = datacontent.data.pages
        })
      }
    },
    setQuest(url) {
      this.quest_selected = url
      this.step_selected = '01'
      this.tab = 'tab-01'
      this.getStep(url)
    },

    setStep(id) {
      this.step_selected = id
    },
    getData() {
      const lang = this.$i18n.locale
      const server = 'https://dashboard.trawlingweb.com/api'
      //const server = this.getServer
      this.$http
        .get(`${server}/faqs/${lang}/list`, this.getTokenHeader)
        .then(data => {
          if (data.data.pages.length > 0) {
            this.quests = data.data.pages
            this.quest_selected = this.quests[0].url
            return this.$http.get(`${server}/faqs/${lang}/${this.quests[0].url}/liststep`, this.getTokenHeader)
          }
        })
        .then(dataquest => {
          if (dataquest.data.pages.length > 0) {
            this.steps = dataquest.data.pages
            this.step_selected = this.steps[0].id
            return this.$http.get(`${server}/faqs/${lang}/${this.quests[0].url}/${this.steps[0].url}`, this.getTokenHeader)
          }
        })
        .then(datastep => {
          this.content = datastep.data
        })
        .catch(() => {
          this.failed = true
        })
    }
  }
}
</script>

<style scope>
.markdown blockquote {
  border-left: 0.25em solid #dfe2e5;
  color: #6a737d;
  padding: 0 1em;
}
.markdown hr {
  margin-bottom: 40px;
}
.markdown h1 {
  /*color: #27408b;*/
  color: #792422;
}
.markdown h2 {
  margin: 30px 0 6px 0;
  /* color: #415eb4;*/
  color: #b34744;
  font-size: 19px;
  font-weight: underline;
}
.markdown h2:first-of-type {
  margin-top: 5px;
}
.markdown h3 {
  font-size: 17px;
  /*color: #607ac7;*/
  color: #ae5a57;
  margin: 10px 0 6px 0;
}
.markdown p {
  font-size: 15px;
  line-height: 17pt;
  text-align: justify;
}
.markdown ul {
  margin: 20px 0 20px 30px;
  font-size: 15px;
  line-height: 17pt;
}
.markdown code {
  padding: 15px;
  margin: 10px 0;
}
.markdown table {
  align-content: center;
  border-collapse: collapse;
  width: 90%;
  margin: 10px 0 35px 30px;
}
.markdown table td {
  margin-left: 40px;
}
.markdown table thead {
  /*background-color: #5f7dd6;*/
  background-color: #f15550;
  color: white;
}
.markdown table tbody tr td,
table thead tr th {
  padding: 5px;
}
#menu {
  background-color: inherit;
  /*color: #27408b;*/
  color: #862724;
  padding: 3px 1px;
  width: 100%;
  border: none;
  outline: none;
  text-align: left;
  transition: 0.3s;
  font-size: 15px;
}
.tw-txt-color-primary {
  /*color: #00ff37 !important;*/
  color: #515151 !important;
}
</style>
